import * as t from "io-ts";
import nullable from "./nullable";
export const featureList = [
    "web-booking",
    "cargo-revision-check",
    "language_se",
    "language_de",
    "language_fi",
    "temperature-on-cargo",
    "undispatched-dialog",
    "news-modal",
    "driver-notebook",
    "webbooking-order-csv-upload",
    "driver-log-place-search",
    "arrived-departed-driver-buttons",
    "driver-report-for-cargo",
    "web-booking-google-search",
    "localized-load-unload-report",
    "saved-locations-visible-to-drivers",
    "hide-expenses",
    "tracker-devices",
    "live-view",
    "mail-orders",
    "scan-readings",
    "live-view-route",
    "cargos-report",
    "mobile-auto-select-customer",
    "map-show-traffic",
    "route-date-search",
    "driver-add-ref-button",
    "driver-add-cubic-meters",
    "gs-group-integration",
    "driver-update-cargo",
    "scheduling-ui",
    "use-cache-for-here-maps",
    "use-cache-for-google-geocoding",
    "use-cache-for-google-reverse-geocoding",
    "gs-group-location-sync",
    "route-view-proactive-update",
    "pricing-agreements",
    "invoicing-ux",
    "calendar-view-test-page",
    "driver-create-dropdowns-dispatchers-cargo",
    "consolidated-invoices-datagrid-combine-rows",
    "validate-stop-order-on-user-rearrange",
    "loading-unloading-template-editor",
    "driver-session-id-from-auth",
    "driver-timesheet extra-hours-columns",
    "check-cargo-revision-when-saving",
    "driver-cargo-time-register",
    "default-dispatcher-view-setting",
    "add-csv-xlsx-cargos-button",
    "lite-version",
    "lite-version-dtl-logo",
    "lite-version-padborg-logo",
    "calendar-view-drop-preview",
    "road-toll-calculation",
    "consolidated-invoices-folders",
    "invoice-folders-autoselect",
    "cargo-emissions-trailers-filtering",
    "drivers-schedules",
    "driver-add-invoice-lines",
    "routing-options-popper",
    "uninstalled-mobile-link-webpage",
    "products-sync-push-websockets",
    "driver-in-app-notifications",
    "mobile-push-notifications",
    "native-driver-login-link",
    "new-teams-filter-components",
    "mobile-document-scan",
    "drivers-add-undispatched-cargos",
    "cargo-requirements-demands-tooltip",
    "teams-cargo-types-qualities-requirements",
    "mobile-app-place-search-with-timeout",
    "referral-link",
    "duplicate-cargo-with-invoice-lines",
    "driver-notebook-multiple",
    "web-booking-api-access",
    "driver-notebook-multiple",
    "automatic-route-archiving",
    "web-booking-view-delivered-status",
    "orgs-subcontracting",
    "fetch-driver-position-from-watch",
    "add-customer",
    "arrived-departed-trigger-stop-times-updates",
    "generate-previews-for-files",
    "upload-photos-directly-to-s3",
    "upload-photos-directly-to-s3__WEB",
    "upload-scans-directly-to-s3",
    "driver-app-caching__delivery-revision-number",
    "driver-app-caching__route-with-stops-version-number",
    "switch-to-native-banner",
    "stop-sort-time-required",
    "dispatcher-place-coords-only",
    "driver-app-edit-delete-notes",
    "driver-app-edit-delete-volumes",
    "driver-app-edit-delete-weights",
    "driver-app-edit-delete-invoice-refs",
    "server-pdf-preview",
    "multiple-stops-added-event-handling",
    "driver-activities-endpoints",
    "mileage-report-updated__only-applies-to-activities",
    "power-office--DEMO-integration",
    "DO NOT TOUCH new-stops-units",
    "mobile-convert-heic-to-jpeg",
    "enable-background-location-watch",
    "mobile-app-cmr-documents-download",
    "mobile-app-debug-alerts",
    "power-office--migration-between-demo-prod-envs",
    "dispatcher-app-version-banner",
    "web-booking-app-version-banner",
    "advanced-scheduling-options",
    "split-cargos-and-routes",
    "copy-cargo-to-driver-routes",
    "update-customer",
    "drivers-app-fetch-products-not-visible-to-drivers",
    "customer-sync-lock--tripletex",
    "customer-sync-lock--power-office",
    "customer-sync-lock--business-central",
    "microsoft-sso",
    "compact-view",
    "driver-activities--create-cargo-no-session",
    "driver-activities--add-dropoff-no-session",
    "users-roles",
    "user-shipment-fields-autocomplete-from-server",
    "edit-consolidated-invoice-lines",
    "edit-consolidated-invoice-lines-in-shipment-modal",
    "consolidated-invoices-move-to-client",
    "invoice-templates-blank-row-between-option",
    "economic-product-groups",
    "undispatched-cargos-alternative-query",
    "get-driver-start-trip-activity-new-query",
    "fetch-all-route-views-activities",
    "routes-extra-filters",
    "failed-invoices-show-errors",
    "paginated-clients-fetch",
    "mobile-app-client-selector-with-refresh",
    "mobile-app-route-updates-websockets",
    "mobile-app-invoice-lines-websockets",
    "dispatcher-views-tabs-as-dropdown",
    "shipment-modal-invoiced-status",
    "dispatcher-app-driver-route-conflicts",
    "insights",
    "insights-charts-v2",
    "schedules-bulk-add-cargos-internal",
    "atomic-route-stop-order-updates",
    "mileage-report-per-cargo-caching",
    "multi-property-route-sort",
    "stop-status-from-route-view",
    "driver-login-from-route-view",
    "admins-disable-users",
    "microsoft-sso-group-access",
    "pickups-dropoffs-many-to-many",
    "mobile-app-bottom-error-toast-instead-of-banner",
    "mileage-report-skip-stationary-distance",
    "skip-unchanged-route-stop-order-events",
    "heroku-orchestrator",
];
export const featureNameT = new t.Type("FeatureName", (input) => typeof input === "string" && featureList.includes(input), (input, context) => {
    if (typeof input === "string" &&
        featureList.includes(input)) {
        return t.success(input);
    }
    return t.failure(input, context);
}, t.identity);
export const featureStatusListT = t.readonlyArray(t.strict({
    name: featureNameT,
    enabled: t.boolean,
    description: t.string,
    lastUpdatedAt: nullable(t.string),
    lastUpdatedByEmail: nullable(t.string),
}));
export const organisationFeatureConfigListT = t.readonlyArray(t.strict({
    name: featureNameT,
    enabled: nullable(t.boolean),
    lastUpdatedAt: nullable(t.string),
    lastUpdatedByEmail: nullable(t.string),
}));
//# sourceMappingURL=feature-list.js.map